<template>
  <div class="headerTop">
    <router-link to="/index" style="height: 28px;">
      <img class="logo" src="@/assets/img/logo.png" alt />
    </router-link>
    <div class="header-right">
      <div class="header-tab">
        <div class="tab-item" @click="goTo('Index')">产品介绍</div>
        <a class="tab-item" href="https://toolplugin.jiaoyanyun.com/api/plugin/video-tool/download-latest">客户端下载</a>
      </div>
      <div v-if="!isLogin" class="login-btn xjs-btn-primary" @click="showLoginModal">登录</div>
      <div v-if="isLogin">
        <el-popover
          v-model="visible"
          popper-class="custom-popover"
          placement="bottom"
          title=""
          :offset="offset"
          :append-to-body="false"
          width="216"
          trigger="hover">
          <div slot="reference" class="avatar">
            <img :src="userInfo.avatar || defaultAvater" />
          </div>
          <div class="header-popover">
            <div class="header-userinfo">
              <img class="avatar-big" @click="clickMenu(1)" :src="userInfo.avatar || defaultAvater" />
              <div class="username ellipsis1">{{orgInfo.user_name}}</div>
              <div class="groupname ellipsis1" v-if="orgInfo.id!==1">{{orgInfo.name}}</div>
            </div>
            <div class="header-line"></div>
            <div class="header-menu">
              <div class="menu-item" @click="clickMenu(1)">
                <img class="menu-item-icon" src="@/assets/img/user.png" />
                <span>个人主页</span>
              </div>
              <div class="menu-item" @click="clickMenu(2)">
                <img class="menu-item-icon" src="@/assets/img/record.png" />
                <span>观看历史</span>
              </div>
            </div>
            <div class="header-line"></div>
            <div class="header-menu">
              <div class="menu-item" v-popover:popover>
                <img class="menu-item-icon" src="@/assets/img/switch.png" />
                <span>切换身份</span>
                <div class="menu-item-right"><img src="@/assets/img/rightArrow.png" /></div>
              </div>
              <div class="menu-item" @click="clickMenu(4)">
                <img class="menu-item-icon" src="@/assets/img/logout.png" />
                <span>退出登录</span>
              </div>
            </div>
            <el-popover
              ref="popover"
              popper-class="custom-popover"
              title=""
              :append-to-body="false"
              width="230"
              :visible-arrow="false"
              :offset="offset1"
              placement="left"
              trigger="hover">
              <div class="header-group">
                <div class="group-title">个人</div>
                <div class="group-item" @click="selectGroup(1)">
                  <div class="group-avatar color0">个</div>
                  <div>
                    <div class="item-name">个人用户</div>
                    <div class="item-subname">仅自己可见，不归属学校</div>
                  </div>
                  <div class="group-item-right">
                    <img src="@/assets/img/sure.png" class="sure-icon" v-if="orgInfo.id==1" />
                  </div>
                </div>
                <div class="group-title" v-if="orgList.length > 1">学校</div>
                <div class="group-item" @click="selectGroup(item.id)" v-for="(item,index) in orgList.slice(1)" :key="index">
                  <div class="group-avatar" :data-index="index" :class="getColor(index)">{{ item.name.substr(0, 1)}}</div>
                  <div class="item-name">{{ item.name }}</div>
                  <div class="group-item-right">
                    <img src="@/assets/img/sure.png" class="sure-icon" v-if="orgInfo.id==item.id" />
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
        </el-popover>
      </div>
    </div>
    <LoginModal />
  </div>
</template>

<script>
import LoginModal from '@/views/pc/Login/LoginModal.vue'
import defaultAvater from '@/assets/img/default-avatar-2.png'
import {SCHOOL_Id,USER_INFO} from '@/js/utils/constant.js'
import store from '@/store'
import { mapState, mapGetters } from 'vuex'
import { logOut } from '@/js/utils/login.js'

export default {
  name: 'Header',
  data() {
    return {
      defaultAvater,
      offset: -85,
      offset1: 20,
      visible: false,
      showBox: false,
      isLogin: false,
    }
  },
  components: { LoginModal },
  computed: {
    ...mapState({
      userInfo: state => state.User.userInfo,
    }),
    ...mapGetters({
      orgInfo: "User/orgInfo",
      orgList: "User/orgList"
    })
  },
  methods: {
    getColor(index) {
      const value = (index+1) % 5
      return 'color' + value
    },
    clickMenu(type) {
      if (type != 3) this.visible = false
      switch(type) {
        case 1:
          const query = {
            userId: this.userInfo.encryptedSaasId,
            schoolId: this.userInfo.encryptedOrgId,
          }
          const route = this.$router.resolve({
            name: 'pcHome',
            query
          })
          window.open(route.href, '_blank')
          break;
        case 2:
          this.goTo('pcHistory')
          break;
        case 3:
          this.showBox = true
          break;
        case 4:
          this.logOutHandler()
          break;
      }
    },
    selectGroup(orgId) {
      this.showBox = false
      this.visible = false
      this.$refs.popover.doClose()
      if(orgId==this.orgInfo.id) return
      this.$store.dispatch('User/changeOrg',orgId)
    },
    goTo(name) {
      const route = this.$router.resolve({
        name
      })
      window.open(route.href, '_blank')
    },
    logOutHandler() {
      logOut()
    },
    showLoginModal() {
      this.$bus.$emit('changeLoginModal', true)
    },
    loginSuccess() {
      this.isLogin = true
    },
    updateUserInfo(newUserInfo) {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      if (query.userId) {
        query.userId = newUserInfo.encryptedSaasId
      }
      if (query.schoolId) {
        query.schoolId = newUserInfo.encryptedOrgId
      }
      query.time = Date.now()
      // 切换机构改变个人主页地址
      this.$router.replace({
        name: this.$route.name,
        query: query
      })
      location.reload()
    }
  },
  mounted() {
    let userInfoStr = localStorage.getItem(USER_INFO)
    if (userInfoStr) {
      this.isLogin = true
    }
    this.$bus.$on('loginSuccess', this.loginSuccess)
    this.$bus.$on('updateUserInfo', this.updateUserInfo)
    this.$bus.$on('logOutEvent', () => {
      this.isLogin = false
      setTimeout(() => {
        location.reload()
      }, 100)
    })
    this.$bus.$on('changeLoginModal', (bool) => {
      if (bool) this.isLogin = false
    })
  }
};
</script>

<style>
.custom-popover {
  padding: 0;
  border: none;
  background: transparent;
}
</style>

<style lang="scss" scoped>
@import './index.scss';
.headerTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 68px;
  .logo {
    height: 28px;
  }
  .header-right {
    display: flex;
    align-items: center;
  }
  .header-tab {
    display: flex;
    .tab-item {
      padding-right: 40px;
      font-size: 16px;
      font-weight: 400;
      color: #212329;
      cursor: pointer;
      &:hover {
        color: #496FF0;
      }
      &:active {
        color: #1532C3;
      }
    }
  }
  .login-btn {
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    height: 36px;
    line-height: 36px;
    padding: 0 26px;
    cursor: pointer;
  }
  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/pc/index.vue